// Small reusable bits used across pages.
import { cn } from "@/lib/utils";

export function StatCard({ label, value, sublabel, accent, testid }) {
  return (
    <div
      data-testid={testid}
      className="bg-[#0F0F14] border border-border rounded-sm p-4 flex flex-col gap-1"
    >
      <div className="text-[10px] uppercase tracking-widest text-[#71717A]">{label}</div>
      <div className={cn("font-mono text-2xl tabular-nums", accent)}>{value}</div>
      {sublabel ? (
        <div className="text-xs text-[#A0A0AB] mt-0.5">{sublabel}</div>
      ) : null}
    </div>
  );
}

export function SectionTitle({ children, sub, right }) {
  return (
    <div className="flex items-end justify-between mb-4">
      <div>
        <h2 className="text-2xl font-semibold tracking-tight">{children}</h2>
        {sub ? <p className="text-sm text-[#A0A0AB] mt-1">{sub}</p> : null}
      </div>
      {right}
    </div>
  );
}

export function Badge({ children, kind = "neutral", testid }) {
  const cls = {
    long: "long-bg",
    short: "short-bg",
    warn: "warn-bg",
    neutral: "bg-[#1A1A22] border border-border text-[#A0A0AB]",
    on: "bg-[#00E676]/10 border border-[#00E676]/30 text-[#00E676]",
    off: "bg-[#27272A]/40 border border-border text-[#71717A]",
  }[kind] || "bg-[#1A1A22] border border-border text-[#A0A0AB]";
  return (
    <span data-testid={testid} className={cn("inline-flex items-center px-2 py-0.5 rounded-sm text-[10px] font-bold uppercase tracking-wider", cls)}>
      {children}
    </span>
  );
}
